export default __webpack_public_path__ + "static/headphonesbw-477c669a80d0b33ee738fd14ef241f13.png";